module.exports = __webpack_public_path__ + "static/media/logo3.2ceca6d7.png";